import moment from "moment";
import DEFAULT_CONSTANTS from "@/Utilites/constants";

export function GetCurrentTimeUtc() {
  return moment().utc().format();
}

export function GetStartOfMonthDate(date) {
  return moment(date).startOf("month").format("YYYY-MM-DD");
}

export function GetEndOfMonthDate(date) {
  return moment(date).endOf("month").format("YYYY-MM-DD");
}

export function customFormatDate(date, format) {
  return moment(date).format(format);
}

export function today() {
  return moment().format("YYYY-MM-DD");
}

export function tomorrow() {
  return moment().add(1, "days").format("YYYY-MM-DD");
}

export function PreviousDayFromSelectedDate(date) {
  return moment(date).subtract(1, "days").format("YYYY-MM-DD");
}

export function NextDayFromSelectedDate(date) {
  return moment(date).add(1, "days").format("YYYY-MM-DD");
}
export function yesterday() {
  return moment().subtract(1, "days").format("YYYY-MM-DD");
}

export function GetSelectedWeekData(date) {
  let selectedDate = moment(date);
  let weekStart = selectedDate.clone().startOf("isoweek");
  let daysInWeek = [];
  for (let i = 0; i < 7; i++) {
    daysInWeek.push({
      id: i,
      day: moment(weekStart).add(i, "days").format("dddd"),
      date: moment(weekStart).add(i, "days").format("YYYY-MM-DD"),
    });
  }
  return daysInWeek;
}

export function calculateOverallTimeDiffInSec(startTime, endTime) {
  let durations = moment.duration(moment(endTime).diff(startTime));
  let hourDiff = durations.hours();
  let minDiff = durations.minutes();
  let secDiff = durations.seconds();
  return (
    secDiff +
    convertFromHoursToSecond(hourDiff) +
    convertFromMinToSecond(minDiff)
  );
}

export function calculateOverallTimeDiffInHour(startTime, endTime) {
  let durations = moment.duration(moment(endTime).diff(startTime));
  let hourDiff = durations.hours();
  let minDiff = durations.minutes();
  let secDiff = durations.seconds();
  return (
    hourDiff + convertFromSecondsToHour(secDiff) + convertFromMinToHour(minDiff)
  );
}

/** Decimal hours → whole seconds (avoids 1.666…h → 5999s / 01:39 display drift). */
export function hoursDecimalToWholeSeconds(hours) {
  return Math.round((Number(hours) || 0) * 3600);
}

/** Snap decimal hours to the nearest whole second. */
export function snapHoursToWholeSeconds(hours) {
  return hoursDecimalToWholeSeconds(hours) / 3600;
}

/**
 * Snap to nearest whole minute (HH:MM UI has no seconds).
 * Fixes legacy API values stored at ~3 decimals (e.g. 1.666 h → 01:39).
 */
export function hoursDecimalToDisplayMinuteSeconds(hours) {
  const secs = (Number(hours) || 0) * 3600;
  return Math.round(secs / 60) * 60;
}

export function snapHoursToDisplayMinute(hours) {
  return hoursDecimalToDisplayMinuteSeconds(hours) / 3600;
}

/**
 * Hours value safe for nekoapi decimal columns (~3 dp).
 * Example: 1h40m → 1.667, not 1.666666… (which truncates to 1.666 / 01:39).
 */
export function hoursDecimalForLegacyApi(hours) {
  const secs = hoursDecimalToWholeSeconds(hours);
  return Math.ceil((secs * 1000) / 3600) / 1000;
}

/** Stopped-time display: decimal hours → `HH:MM`. */
export function displayHmFromDecimalHours(hours) {
  return convertToHm(hoursDecimalToDisplayMinuteSeconds(hours));
}

export function convertToHm(secs) {
  let time = returnObjectOfHms(secs);
  if (time.hours === 0) {
    return "00:" + [time.minutes].map((v) => (v < 10 ? "0" + v : v));
  }
  return [time.hours, time.minutes]
    .map((v) => (v < 10 ? "0" + v : v))
    .filter((v, i) => v !== "00" || i > 0)
    .join(":");
}

export function convertToHms(secs) {
  let time = returnObjectOfHms(secs);
  if (time.hours < 10) {
    time.hours = "0" + time.hours;
  }
  if (time.minutes < 10) {
    time.minutes = "0" + time.minutes;
  }
  if (time.seconds < 10) {
    time.seconds = "0" + time.seconds;
  }
  return time.hours + ":" + time.minutes + ":" + time.seconds; // Return is HH : MM : SS
}

export function returnObjectOfHms(secs) {
  let number = Math.round(Number(secs) || 0);
  let hours = Math.floor(number / 3600);
  let minutes = Math.floor(number / 60) % 60;
  let seconds = number - hours * 3600 - minutes * 60;
  return {
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  };
}

export function UpdateCurrentTimerData(data, time) {
  let startTime = data.timer_started_at;
  if (startTime === null) return;
  let endTime = GetCurrentTimeUtc();
  data.hours = HHMMSStoHours(time);
  data.hours_with_timer = data.hours;
  data.working_hours = data.hours;
  data.timer_stopped_at = endTime;
  data.timer_started_at = null;
  return data;
}

export function CheckIfTimerIsRunningToday(getTimer) {
  let found = getTimer.find((x) => {
    if (x.timer_started_at != null) {
      return x;
    }
  });
  if (found !== undefined) {
    return found;
  }
  return null;
}

export function convertHMSFormatInputToHours(value) {
  if (value === null || value === undefined || value === "") return;
  const raw = value.toString().trim();
  const check = raw.search(":");
  if (check !== -1) {
    const normalized = HHMMFormat(raw) || raw;
    const a = normalized.split(":");
    return snapHoursToWholeSeconds(+a[0] + +a[1] / 60);
  }
  return snapHoursToWholeSeconds(value);
}

export function HHMMSStoHours(hms) {
  const [hours, minutes, seconds] = hms.split(":");
  return +hours + +minutes / 60 + +seconds / 3600;
}

export function HHMMSStoSeconds(hms) {
  const [hours, minutes, seconds] = hms.split(":");
  return +hours * 3600 + +minutes * 60 + +seconds;
}

export function HHMMFormat(value) {
  if (value.toString() === "" || value.length === 0) return;
  if (value.toString() === ":") return;
  let RegExp = /^\d*:?\d*$/;
  if (!value.match(RegExp)) return;
  let check = value.toString().search(":");
  if (check !== -1) {
    let a = value.split(":");
    if (a[0] === "") {
      a[0] = 0;
    }
    const quotient = (a[1] - (a[1] % 60)) / 60;
    let remainder = a[1] % 60;
    let h = parseInt(a[0]) + quotient;
    if (parseInt(h) < 10) {
      h = "0" + h;
    }
    if (parseInt(remainder) < 10) {
      remainder = "0" + remainder;
    }
    value = h + ":" + remainder;
    return value;
  } else {
    const quotient = (value - (value % 60)) / 60;
    const remainder = value % 60;
    value = quotient + ":" + remainder;
    return value;
  }
}

export function getTimeDifference(startTime, endTime, options) {
  let durations = moment.duration(moment(endTime).diff(startTime));
  switch (options) {
    case "seconds":
      return durations.seconds();
    case "minutes":
      return durations.minutes();
    case "hours":
      return durations.hours();
    case "default":
      return durations;
    default:
      return durations;
  }
}

/** Decimal hours (e.g. 0.0833) → `HH:MM:SS` for the running clock display. */
export function hoursDecimalToHms(hours) {
  const parts = GetCurrentProjectTimerData(Number(hours) || 0);
  return returnHHMMSSFormat({
    hour: parts.hours,
    minute: parts.minutes,
    second: parts.seconds,
  });
}

export function GetCurrentProjectTimerData(hours) {
  const totalSecs = hoursDecimalToWholeSeconds(hours);
  return {
    hours: Math.floor(totalSecs / 3600),
    minutes: Math.floor(totalSecs / 60) % 60,
    seconds: totalSecs % 60,
  };
}

export function getTotalHoursEstimate(items) {
  let sumSecs = 0;
  items.forEach((item) => {
    sumSecs += hoursDecimalToWholeSeconds(item.hours);
  });
  return convertToHm(sumSecs);
}

export function convertFromHoursToSecond(hours) {
  return hours * DEFAULT_CONSTANTS.toSecond;
}

export function convertFromMinToSecond(min) {
  return min * DEFAULT_CONSTANTS.toMin;
}

export function convertFromSecondsToMin(seconds) {
  return Math.floor(seconds / DEFAULT_CONSTANTS.toMin);
}

export function convertFromMinToHour(minutes) {
  return Math.floor(minutes / DEFAULT_CONSTANTS.toMin);
}

export function convertFromHourToMin(min) {
  return min * DEFAULT_CONSTANTS.toMin;
}

export function convertFromSecondsToHour(seconds) {
  return seconds / DEFAULT_CONSTANTS.toSecond;
}

export function reconvertHour(hours) {
  if (hours == null || hours === "") return 0;
  const s = String(hours).trim();
  if (s.includes(":")) {
    const parts = s.split(":");
    if (parts.length >= 3) {
      return HHMMSStoHours(s);
    }
    return HHMMSStoHours(`${parts[0]}:${parts[1]}:00`);
  }
  const n = Number(s);
  return Number.isNaN(n) ? 0 : n;
}

export function ModularDivisionBy(time, divideBy) {
  return time % divideBy;
}

export function calculateProjectTime(startTime, currentProjectTimeData) {
  let currentTime = GetCurrentTimeUtc();
  let timeElapsed = getTimeDifference(startTime, currentTime);
  let hour = timeElapsed.hours();
  let min = timeElapsed.minutes();
  let sec = timeElapsed.seconds();
  //handle cases where the combined number of seconds is greater than 60
  const calculateMinutesFromSeconds = Math.floor(
    (sec + currentProjectTimeData.seconds) / 60
  );
  const remainingSeconds = ModularDivisionBy(
    sec + currentProjectTimeData.seconds,
    DEFAULT_CONSTANTS.toMin
  );
  //handle cases where the combined number of minutes is greater than 60
  const calculateHoursFromMinutes = Math.floor(
    (min + currentProjectTimeData.minutes + calculateMinutesFromSeconds) / 60
  );
  const remainingMinutes = ModularDivisionBy(
    min + currentProjectTimeData.minutes + calculateMinutesFromSeconds,
    DEFAULT_CONSTANTS.toMin
  );
  return {
    hour: hour + calculateHoursFromMinutes + currentProjectTimeData.hours,
    minute: remainingMinutes,
    second: remainingSeconds,
  };
}

export function zeroPrefix(num, digit) {
  const n = Number(num);
  const safe = Number.isFinite(n) ? Math.max(0, Math.floor(n)) : 0;
  let zero = "";
  for (let i = 0; i < digit; i++) {
    zero += "0";
  }
  return (zero + String(safe)).slice(-digit);
}

export function returnHHMMSSFormat(timer) {
  if (!timer) return "00:00:00";
  const HH = zeroPrefix(timer.hour, 2);
  const MM = zeroPrefix(timer.minute, 2);
  const SS = zeroPrefix(timer.second, 2);
  return `${HH}:${MM}:${SS}`;
}
